const API_BASE = (process.env.REACT_APP_MORFEUSZ_4E_API_URL || "").replace(/\/$/, "");
const TOKEN_KEY = "morfeusz:auth:token";

const authUrl = (path) => `${API_BASE}/auth/${path}`;

export const getAuthToken = () => {
  if (typeof window === "undefined") return "";
  try {
    return window.localStorage.getItem(TOKEN_KEY) || "";
  } catch (_) {
    return "";
  }
};

export const setAuthToken = (token) => {
  if (typeof window === "undefined") return;
  try {
    if (token) window.localStorage.setItem(TOKEN_KEY, token);
    else window.localStorage.removeItem(TOKEN_KEY);
  } catch (_) {
    /* ignore */
  }
};

const authHeaders = (headers = {}) => {
  const token = getAuthToken();
  return {
    ...headers,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

const parseResponse = async (response) => {
  const data = await response.json().catch(() => null);
  if (!response.ok || !data?.ok) {
    const error = new Error(data?.message || `auth-http-${response.status}`);
    error.code = data?.code || `auth-http-${response.status}`;
    error.status = response.status;
    throw error;
  }
  return data;
};

const post = async (path, body = {}) => {
  if (!API_BASE) {
    const error = new Error("auth-api-missing");
    error.code = "auth-api-missing";
    throw error;
  }

  const response = await fetch(authUrl(path), {
    method: "POST",
    credentials: "include",
    headers: authHeaders({
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(body),
  });
  return parseResponse(response);
};

const get = async (path) => {
  if (!API_BASE) {
    const error = new Error("auth-api-missing");
    error.code = "auth-api-missing";
    throw error;
  }

  const response = await fetch(authUrl(path), {
    method: "GET",
    credentials: "include",
    headers: authHeaders(),
  });
  return parseResponse(response);
};

export const authClient = {
  isConfigured: () => Boolean(API_BASE),
  me: () => get("me"),
  login: ({ email, password }) => post("login", { email, password }),
  register: ({ email, password, displayName }) => post("register", { email, password, displayName }),
  requestPasswordChange: ({ returnBase }) => post("request-password-change", { returnBase }),
  changePassword: ({ currentPassword, newPassword, vault, passwordChangeToken }) => post("change-password", {
    currentPassword,
    newPassword,
    vault,
    passwordChangeToken,
  }),
  requestAccountDelete: () => post("request-account-delete"),
  revoke: () => post("revoke"),
  logout: () => post("logout"),
  clearToken: () => setAuthToken(""),
  setToken: setAuthToken,
  getToken: getAuthToken,
};
